// eslint-disable-next-line import/prefer-default-export
export const RESET_SESSION = 'RESET_SESSION';
